import React from "react";
import { Link } from "react-router-dom";
import "./AllSolutionsRequestNewProject.css";
import { FiPhone } from "react-icons/fi";
import mainImage from "../../../../assets/images/allsolutions/main2.webp"

const AllSolutionsRequestNewProject = () => {
  return (
    <section className="allSolutionsRequestNewProject">
      <div className="allSolutionsRequestNewProject-top">
        <div className="allSolutionsRequestNewProject-content">
          <span className="allSolutionsRequestNewProject-tag">CONTACT US</span>

          <h2 className="allSolutionsRequestNewProject-title">
            Starting a <span>new project?</span>
          </h2>

          <p className="allSolutionsRequestNewProject-text">
            IRQGYP is a leading Iraqi company specialized in gypsum products
            and modern construction solutions — headquartered in Baghdad.
          </p>

          <div className="allSolutionsRequestNewProject-actions">
            <Link to="/contactus#contact-form" className="buttongyp allSolutionsRequestNewProject-quoteBtn">
              Get a quote
            </Link>

            <Link to="/contactus#contact-form" className="allSolutionsRequestNewProject-callBtn">
              <span>Request a Call back</span>
              <FiPhone className="allSolutionsRequestNewProject-phoneIcon" />
            </Link>
          </div>
        </div>
      </div>

      <div className="allSolutionsRequestNewProject-imageWrap">
        <img
          src={mainImage}
          alt="Worker holding gypsum board"
          className="allSolutionsRequestNewProject-image"
        />

      </div>
    </section>
  );
};

export default AllSolutionsRequestNewProject;